import {RestResource} from "../rest";
import {ASSESSMENT_SERVER} from "../server";
import {athubAxios} from "../../util/athub-axios";

const addsubRecord = new RestResource({server: ASSESSMENT_SERVER, resource: 'addsubRecord'});

addsubRecord.batchUpdate = (addsubRecords) => {
    let url = `${ASSESSMENT_SERVER}/addsubRecord/batch`;
    return new Promise((resolve, reject) => {
        athubAxios.put(url, addsubRecords).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

export default addsubRecord;